import { useGetUserMetricsQuery } from '@/affiliate-dashboard/graphql';
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/base/select';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useIntl } from 'react-intl';

export function AddDiscountCode({
  handleAddDiscount,
}: {
  handleAddDiscount: (code: string) => void;
}): JSX.Element {
  const { data } = useGetUserMetricsQuery();
  const sortedCouponCodes = (data?.userMetrics?.couponCodes ?? []).sort(
    (a, b) =>
      (JSON.parse(b?.couponConfig ?? '{}') as { amount: number }).amount -
      (JSON.parse(a?.couponConfig ?? '{}') as { amount: number }).amount,
  );
  const [discountCode, setDiscountCode] = useState(
    sortedCouponCodes[0]?.couponCodeRequested ?? '',
  );

  const { t } = useTranslation();
  const intl = useIntl();

  return (
    <fieldset>
      <Select
        onValueChange={(currentValue: string) => {
          setDiscountCode(currentValue);
          handleAddDiscount(currentValue);
        }}
        value={discountCode}
      >
        <SelectTrigger
          data-testid="select-account-trigger"
          size="sm"
          variant="secondary"
        >
          <SelectValue placeholder={t('addDiscountCode.discountPlaceholder')} />
        </SelectTrigger>
        <SelectContent>
          <SelectGroup
            data-testid="select-account-content"
            className="divide-y divide-default-gray-800"
          >
            {sortedCouponCodes.map(
              (code) =>
                code?.couponCodeRequested && (
                  <SelectItem
                    key={code?.couponCodeRequested}
                    data-testid="rise"
                    value={code?.couponCodeRequested}
                  >
                    <div className="flex w-full items-center gap-2">
                      <span>{code?.couponCodeRequested}</span>
                      <span className="text-sm text-default-gray-400">
                        (
                        {intl.formatNumber(
                          ((
                            JSON.parse(code?.couponConfig ?? '{}') as {
                              amount: number;
                            }
                          ).amount ?? 0) / 100,
                          {
                            style: 'percent',
                            maximumFractionDigits: 3,
                          },
                        )}
                        )
                      </span>
                    </div>
                  </SelectItem>
                ),
            )}
            {data?.userMetrics.activeCampaignsCoupons
              ? data?.userMetrics.activeCampaignsCoupons.map(
                  (code) =>
                    code?.code && (
                      <SelectItem
                        key={code?.code}
                        data-testid="rise"
                        value={code?.code}
                      >
                        <div className="flex w-full items-center gap-2">
                          <span>{code?.code}</span>
                          <span className="text-sm text-default-gray-400">
                            (
                            {intl.formatNumber(
                              ((
                                JSON.parse(code?.config ?? '{}') as {
                                  amount: number;
                                }
                              ).amount ?? 0) / 100,
                              {
                                style: 'percent',
                                maximumFractionDigits: 3,
                              },
                            )}
                            )
                          </span>
                        </div>
                      </SelectItem>
                    ),
                )
              : null}
          </SelectGroup>
        </SelectContent>
      </Select>
    </fieldset>
  );
}
